import baseRoute from './baseRoute';
import LoginPage from '@/views/LoginPage.vue';

export default (guards = null) =>
  baseRoute(
    {
      path: '/login',
      component: LoginPage,
      meta: {
        title: 'Logowanie'
      }
    },
    guards
  );
